
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/material-ui-v7-is-here",
      function () {
        return require("private-next-pages/blog/material-ui-v7-is-here.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/material-ui-v7-is-here"])
      });
    }
  